module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/legend.add8556.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/legend.jpg
// module id = L+OL
// module chunks = 0